import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardComparisonStatisticsModel } from 'src/app/models/statistics/dashboard-comparison-statistics.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

@Component({
    selector: 'app-dashboard-statistics-widget',
    templateUrl: './dashboard-statistics-widget.component.html',
    styleUrl: './dashboard-statistics-widget.component.scss',
    standalone: false
})
export class DashboardStatisticsWidgetComponent {
  dashboardStatistics!: DashboardComparisonStatisticsModel;

  constructor(
    private router: Router,
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {
    
  }

  ngOnInit() {
    this.dashboardWidgetsDataService.getDashboardStatistics().subscribe(data => {
      if (data) {
        this.dashboardStatistics = data;
      } else {
        this.dashboardStatistics = {} as DashboardComparisonStatisticsModel;
      }
    });
  }

  onUniqueLoginsClick() {
    this.router.navigate(['/employee'], {
      queryParams: { persons: JSON.stringify(this.dashboardStatistics.activeEmployeeIds) },
    });
  }

  onInactiveEmployeesClick() {
    this.router.navigate(['/employee'], {
      queryParams: { persons: JSON.stringify(this.dashboardStatistics.inactiveEmployeeIds) },
    });
  }
}
